initSegment = ->
  # Create a queue, but don't obliterate an existing one!
  analytics = window.analytics = window.analytics or []
  # If the real analytics.js is already on the page return.
  if analytics.initialize
    return
  # If the snippet was invoked already show an error.
  if analytics.invoked
    if window.console and console.error
      console.error 'Segment snippet included twice.'
    return
  # Invoked flag, to make sure the snippet
  # is never invoked twice.
  analytics.invoked = true
  # A list of the methods in Analytics.js to stub.
  analytics.methods = [
    'trackSubmit'
    'trackClick'
    'trackLink'
    'trackForm'
    'pageview'
    'identify'
    'reset'
    'group'
    'track'
    'ready'
    'alias'
    'page'
    'once'
    'off'
    'on'
  ]
  # Define a factory to create stubs. These are placeholders
  # for methods in Analytics.js so that you never have to wait
  # for it to load to actually record data. The `method` is
  # stored as the first argument, so we can replay the data.

  analytics.factory = (method) ->
    ->
      args = Array::slice.call(arguments)
      args.unshift method
      try
        analytics.push args
      catch
      analytics

  # For each of our methods, generate a queueing stub.
  i = 0
  while i < analytics.methods.length
    key = analytics.methods[i]
    analytics[key] = analytics.factory(key)
    i++
  # Define a method to load Analytics.js from our CDN,
  # and that will be sure to only ever load it once.

  analytics.load = (key) ->
    # Create an async script element based on your key.
    script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = "#{document.location.protocol}//cdn.segment.com/analytics.js/v1/#{key}/analytics.min.js"
    # Insert our script next to the first script element.
    first = document.getElementsByTagName('script')[0]
    first.parentNode.insertBefore script, first
    return

  # Add a version to keep track of what's in the wild.
  analytics.SNIPPET_VERSION = '3.1.0'
  # Load Analytics.js with your key, which will automatically
  # load the tools you've enabled for your account. Boosh!
  analyticsKeysRaw = document.querySelector("meta[name='analytics']")?.dataset?.analytics
  analyticsKeys = analyticsKeysRaw and JSON.parse(analyticsKeysRaw)
  segmentApiKey = analyticsKeys?["Segment.io"]?.apiKey
  analytics.load(segmentApiKey) if segmentApiKey
  # Make the first page call to load the integrations. If
  # you'd like to manually name or tag the page, edit or
  # move this call however you'd like.

  return
document.addEventListener("DOMContentLoaded", initSegment)
# ---
# generated by js2coffee 2.1.0
